// Banner de promociones, gestionado desde el admin del backend
// (ecommercejwt). `texto` viene null si no hay ninguna promoción vigente
// -- el banner se oculta en ese caso.
import { request } from './ecommerceClient';

export const getPromoActiva = () => request('/promociones/activa');
